<img src="/assets/img/alert-payment-icon.svg" alt="warning" class="warning-icon">
<div *ngIf="isOwner" class="alert-text">
  <span>{{'PAYMENT_FAILED_ALERT.OWNER_HEADER' | translate}}</span>&nbsp;
  <a href="#" *ngIf="directPayment" (click)="contactSupport()">
    <span [innerHTML]="'PAYMENT_FAILED_ALERT.OWNER_CONTACT_SUPPORT' | translate"></span>
  </a>
  <a href="#" *ngIf="!directPayment" (click)="pay()">
    <span [innerHTML]="'PAYMENT_FAILED_ALERT.OWNER_PAY' | translate"></span>
  </a>
</div>
<div *ngIf="!isOwner" class="alert-text" [innerHTML]="'PAYMENT_FAILED_ALERT.USER' | translate"></div>
